import { modifier } from 'ember-modifier';

export default modifier(function rememberElement(element, [callback]) {
  if (typeof callback === 'function') {
    callback(element);
  }
});
